import { MutationTree } from "vuex";
import { CompanyState, CompanyMutations } from "@/store/interfaces/company";
import { MutationTypes } from "./mutation-types";

export const mutations: MutationTree<CompanyState> & CompanyMutations = {
  /**
    Mutation for company wizard from Company module state
    @param state - Company module state
    @param payload - {
      status: boolean;
      didInvalidate: boolean;
      companyId: string;
      companyName: string;
      companyUrl: string;
      receivedAt: number;
      connectionError: boolean;
    }
  */
  [MutationTypes.COMPANY_SET_WIZARD](state, payload) {
    state.wizard = payload;
  },

  /**
    Mutation for company from CompaNy module state
    @param state - Company module state
    @param payload - {
      status: boolean;
      didInvalidate: boolean;
      companyId: string;
      companyName: string;
      companyUrl: string;
      receivedAt: number;
      connectionError: boolean;
    }
  */
  [MutationTypes.COMPANY_SET_COMPANY](state, payload) {
    state.company = payload;
  }
};
